const blogPosts = [
  {
    slug: 'ai-security-threat-detection',
    title: 'AI Security Playbook: Threat Detection for Healthcare & Defense',
    date: '2024-11-15',
    category: 'AI Security',
    tags: ['Threat Detection', 'Compliance', 'Zero Trust'],
    author: 'Sapiencia.AI Team',
    excerpt:
      'How Sapiencia.AI applies layered threat detection, zero trust, and compliance-first controls to protect AI systems in healthcare and defense environments.',
    readingTime: '6 min read',
    metaDescription:
      'Inside Sapiencia.AI’s approach to AI threat detection for healthcare and defense: layered monitoring, secure data pathways, and compliance-first controls.',
    content: [
      {
        type: 'paragraph',
        text:
          'AI workloads that handle PHI or national security data demand controls that go beyond traditional perimeter defenses. Sapiencia.AI builds threat detection into every stage of the AI lifecycle—from data ingestion to model serving—so healthcare and defense teams can deploy responsibly.',
      },
      {
        type: 'heading',
        text: 'What “secure by design” means for AI systems',
      },
      {
        type: 'list',
        items: [
          'Continuous telemetry across data pipelines, model endpoints, and identity events to spot anomalous access or data drift early.',
          'Zero trust access for clinicians, analysts, and developers, backed by strong identity, device posture checks, and role-aware policies.',
          'Compliance guardrails mapped to HIPAA, NIST 800-53, and DoD guidance so security teams can ship faster without creating audit gaps.',
        ],
      },
      {
        type: 'heading',
        text: 'How Sapiencia.AI detects emerging threats',
      },
      {
        type: 'list',
        items: [
          'Model-aware monitoring that flags prompt injection attempts, jailbreak patterns, and unusual output distributions.',
          'Data lineage tracking to prevent unauthorized data movement between clinical, research, and tactical environments.',
          'Automated policy checks that block deployments when encryption, logging, or isolation standards are not met.',
        ],
      },
      {
        type: 'paragraph',
        text:
          'These controls integrate with existing SOC workflows so teams keep their current SIEM, ticketing, and incident response tools while gaining AI-specific visibility.',
      },
      {
        type: 'heading',
        text: 'Outcomes for regulated teams',
      },
      {
        type: 'paragraph',
        text:
          'Healthcare teams reduce PHI exposure risk and strengthen HIPAA reporting. Defense programs get mission-ready AI that respects zero trust principles without slowing operators in the field.',
      },
      {
        type: 'paragraph',
        text:
          'Want a deeper walkthrough? Request a demo to see how these controls map to your data flows and accreditation requirements.',
      },
    ],
  },
];

export default blogPosts;
